import React from 'react'
import Constants from 'EurestoFonction/Constants'
import DataComponent from '../../../DataComponents/index'
import Grid from '@material-ui/core/Grid'
import User from 'EurestoClass/User'
import ApiRequest from 'EurestoApi/ApiRequest'
import EurestoForm from 'Components/Form'
import Input from 'Components/Input'
import Utils from 'EurestoFonction/Utils'


const project = require('EurestoConfig/project.config')

export default class extends React.Component {
  constructor (props) {
    super(props)
    const newState = {
      ...props,
      action: props.action,
      key: Utils.getRandomNumber()
    }
    this.state = {
      saveState: { ...EurestoClone(newState)},
      ...newState
    }
  }

  componentDidMount () {
    if (this.state.action === 'update' || this.state.action === 'duplicate' || this.state.action === 'view') {
      this.getActivite()
    }
  }

  getActivite = async () => {
    const result = await ApiRequest(project.api + 'configuration', {
      requete: 'user',
      action: 'get',
      id: this.state.id
    }, { showAlertError: false })
    if(result && result.code === 1) {
      const newState = {
        nom: result.results.nom || '',
        prenom: result.results.prenom || '',
        email: result.results.email || '',
        fixe: result.results.fixe || '',
        portable: result.results.portable || '',
        civilite_id: result.results.civilite_id || undefined,
        qualite_id: result.results.qualite_id || undefined,
        media_id: result.results.media_id || '',
        media_lien: result.results.media_lien,
        profil_v2_id: result.results.profil_v2_id || undefined,
      }
      this.setState({
        saveState: { action: 'view', ...EurestoClone(this.state.saveState), ...EurestoClone(newState) },
        ...newState,
        key: Utils.getRandomNumber()
      }, this.forceUpdate)
    }
  }

  onChangeState = (e, name) => {
    this.setState({
      [name]: e
    }, this.forceUpdate)
  }

  onCancel = () => {
    this.setState({
      nom: '',
      prenom: '',
      email: '',
      fixe: '',
      portable: '',
      civilite_id: undefined,
      qualite_id: undefined,
      media_id: undefined,
      profil_v2_id: undefined,
      key: Utils.getRandomNumber(),
      action: 'add',
    }, () => this.props.onCancel())
  }

  onSave = async (action) => {
    const result = await ApiRequest(project.api + 'configuration', {
      requete: 'user',
      action: action === 'update' ? 'update' : 'add',
      id: this.state.id,
      nom: this.state.nom || '',
      prenom: this.state.prenom || '',
      email: this.state.email || '',
      fixe: this.state.fixe || '',
      portable: this.state.portable || '',
      civilite_id: this.state.civilite_id || undefined,
      qualite_id: this.state.qualite_id || undefined,
      media_id: this.state.media_id || '',
      profil_v2_id: this.state.profil_v2_id || undefined,
    })
    if (result.code === 1) {
      this.onCancel()
    }
  }

  onDelete = async () => {
    const r = await ApiRequest(project.api + 'configuration', {
      requete: 'user',
      action: 'delete',
      id: this.state.id,
    })
    if (r && r.code === 1) {
      this.setState({
        action: this.props.isAllow && (this.props.isAllow.add && 'add' || ' ')
      })
    }
  }

  onArchive = async () => {
    console.log('not done yet')
  }

  onView = (action) => {
    const newState = this.state.saveState
    newState.saveState = {...EurestoClone(this.state.saveState)}
    newState.key = Utils.getRandomNumber();
    const keys = Object.keys(this.state)
    const stateReset = keys.reduce((acc, v) => ({ ...acc, [v]: undefined }), {})
    this.setState({
      ...stateReset,
      ...newState
    }, action === 'add' && this.props.onCancel(false) || this.forceUpdate)
  }

  form = (disabled, autoFocus) => {
    return (
      <Grid container spacing={0} style={{margin: 0, padding: 0}} justify={'flex-start'} alignItems={'flex-start'}>
        <Grid item xs={4} style={{margin: 0, padding: 2.5}}>
          <DataComponent
            onChange={this.onChangeState}
            name="picture"
            type={Constants.typeSaisie.Picture}
            avatarStyle={{maxWidth: '90%'}}
            defineData={true}

            data={{
              id: this.state.media_id,
              lien: this.state.media_lien
            }}
            object={{
              picture: {
                id: this.state.media_id,
                lien: this.state.media_lien
              },
              id: this.state.id,
            }}/>
          {
            User.TypeAccess.get(Constants.access.ETABLISSEMENT) &&

            <DataComponent
              name="profil_v2_id"
              type={Constants.typeSaisie.ComboSimple}
              onChange={this.onChangeState}

              data={this.state.profil_v2_id}
              object={Constants.donnee.profil}
              module={Constants.module.CONFIGURATION}
            />
          }
        </Grid>
        <Grid item xs={8} style={{margin: 0, padding: 2.5}}>
          <Grid container spacing={0} style={{margin: 0, padding: 0}} direction="column" justify="center"
                alignItems="stretch">
            <DataComponent
              name="civilite_id"
              autoFocus={autoFocus}
              type={Constants.typeSaisie.ComboSimple}
              onChange={this.onChangeState}

              data={this.state.civilite_id}
              object={Constants.donnee.civilite}
              module={Constants.module.COMMUN}
              search={{type: 1}}
            />
            <Input
              onChange={this.onChangeState}
              name="nom"
              type="text"
              className="upText"
              value={this.state.nom}
              title={EurestoI18n.t('crm:Nom')}
            />
            <Input
              onChange={this.onChangeState}
              name="prenom"
              type="text"
              value={this.state.prenom}
              title={EurestoI18n.t('crm:Prénom')}
            />
            <Input
              onChange={this.onChangeState}
              name="email"
              type="text"
              value={this.state.email}
              title={EurestoI18n.t('crm:Email')}
            />
            <Input
              onChange={this.onChangeState}
              name="fixe"
              type="text"
              value={this.state.fixe}
              title={EurestoI18n.t('crm:Téléphone Fixe')}
            />
            <Input
              onChange={this.onChangeState}
              name="portable"
              type="text"
              value={this.state.portable}
              title={EurestoI18n.t('crm:Téléphone Portable')}
            />
          </Grid>
        </Grid>
      </Grid>
    )
  }

  render () {
    return (
      <EurestoForm key={this.state.key}
                   {...this.props.formProps}
                   libelle={this.state.nom}
                   action={this.state.action}
                   isAllow={{...this.props.isAllow, update: true}}
                   onSave={this.onSave}
                   onCancel={this.onCancel}
                   onDelete={this.onDelete}
                   onArchive={this.onArchive}
                   onView={this.onView}
                   libelleAdd={EurestoI18n.t('commun:Nouvel utilisateur')}
                   children={this.form}/>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataForm/Template/Configuration/Utilisateur.js